import request from "@/utils/request";
//测试api
export function testApi(){
 return Promise.resolve({
     err_code:0
 })
}

//1,获取学生列表
export function getMembers(data){
    return request({
        url:'/team/getMembers',
        data:data,
        method:'get'
    })
}
//2,添加学生
export function addMember(data){
    return request({
        url:'/team/addMember',
        data:data,
        method:'post'
    })
}
//3,编辑学生
export function updateMember(data){
    return request({
        url:'/team/updateMember',
        data:data,
        method:'post'
    })
}

//查询单个队员信息
export function getMemberDetail(data){
    return request({
        url:'/team/getMemberDetail',
        data:data,
        method:'get'
    })
}

//删除队员
export function removeMember(data){
    return request({
        url:'/team/removeMember',
        data:data,
        method:'post'
    })
}
//4,检测参赛队名是否可用
export function checkTeamName(data){
    return request({
        url:'/checkTeamName',
        data:data,
        method:'get'
    })
}
// 5 更新参赛队信息 （参赛队队长更新）
export function updateTeam(data){
    return request({
        url:'/team/updateTeam',
        data:data,
        method:'post'
    })
}

//1,获取老师列表
export function getTeachers(data){
    return request({
        url:'/team/getTeachers',
        data:data,
        method:'get'
    })
}
//2,添加老师
export function addTeacher(data){
    return request({
        url:'/team/addTeacher',
        data:data,
        method:'post'
    })
}
//3,编辑老师
export function updateTeacher(data){
    return request({
        url:'/team/updateTeacher',
        data:data,
        method:'post'
    })
}

//查询单个老师信息
export function getTeacherDetail(data){
    return request({
        url:'/team/getTeacherDetail',
        data:data,
        method:'get'
    })
}

//删除老师
export function removeTeacher(data){
    return request({
        url:'/team/removeTeacher',
        data:data,
        method:'post'
    })
}
//获取下载文件
export function getDocs(data){
    return request({
        url:'/getDocs',
        data:data,
        method:'get'
    })
}


//获取选题，作品上报用
export function getTopics(data){
    return request({
        url:'/getTopics',
        data:data,
        method:'get'
    })
}
//添加参数作品
export function addWork(data){
    return request({
        url:'/team/addWork',
        data:data,
        method:'post'
    })
}
//获取当前队伍参数作品信息
export function getWork(data){

    return request({
        url:'/team/getWork',
        data:data,
        method:'get'
    })
}
//修改当前队伍的参数信息
export function updateWork(data){
    return request({
        url:'/team/updateWork',
        data:data,
        method:'post'
    })
}

//获取预览接口
export function genPreviewurl(data){
    return request({
        url:'/team/genPreviewUrl',
        data:data,
        method:'post'
    })
}

// 获取复赛文件
export function FinalFiledetail(data){
    return request({
        url:'/team/FinalFile/detail',
        data:data,
        method:'get'
    })
}
// 上传决赛文件
export function FinalFiledNew(data){
    return request({
        url:'/team/FinalFile/new',
        data:data,
        method:'post'
    })
}
// 更新决赛文件
export function FinalFiledUpdate(data){
    return request({
        url:'/team/FinalFile/update',
        data:data,
        method:'post'
    })
}
